import { useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { trackRendererRendered } from '../analytics/useForgeUiAnalyticsEvent';
import { useMetricsContext } from '../context/metrics';
export var useSendRendererRenderedAnalytics = function useSendRendererRenderedAnalytics() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useMetricsContext = useMetricsContext(),
    source = _useMetricsContext.page;
  useEffect(function () {
    trackRendererRendered(createAnalyticsEvent, {
      source: source,
      target: 'renderer'
    });
  });
};